import { render, staticRenderFns } from "./kdxSvgIcon.g.vue?vue&type=template&id=7f14b2e8&scoped=true"
import script from "./kdxSvgIcon.g.vue?vue&type=script&lang=js"
export * from "./kdxSvgIcon.g.vue?vue&type=script&lang=js"
import style0 from "./kdxSvgIcon.g.vue?vue&type=style&index=0&id=7f14b2e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f14b2e8",
  null
  
)

export default component.exports